
import API_CALL from '../API';

export interface HistoryResponse {
  offset: number;
  limit: number;
  from: null;
  to: null;
  client_id: null;
  folder: string;
  pathname: null;
  count: number;
  operation_history: Operationhistory[];
}

export interface Operationhistory {
  commit: Commit;
  operations: Operation[];
  is_truncated: boolean;
}

export interface Operation {
  key: string;
  paired_key: null;
  etag: null;
  size: number;
  lmtime: number;
  version_id: number;
  operation: number;
  has_content: boolean;
}

export interface Commit {
  commit_id: number;
  basis: string;
  timestamp: number;
  client_id: number;
}
interface VersionHistoryParams {
  folder: string;
  limit?: number;
}

export const getHistory = async ({
  folder,
  limit = 10,
}: VersionHistoryParams ): Promise<HistoryResponse> => {
  try {
    return await API_CALL({
      url: '/versioning/history',
      method: 'GET',
      params: { folder, limit },
    }).then((res) => res as HistoryResponse);
  } catch (err) {
    console.error('Versioning history fetch failed', err);
    throw err;
  }
};


export const VersioningService = {
  getHistory,
};
